const ENTER = 13;
const CHANNEL_UP = 33;
const CHANNEL_DOWN = 34;
const LEFT = 37;
const UP = 38;
const RIGHT = 39;
const DOWN = 40;
const ZERO = 48;
const ONE = 49;
const TWO = 50;
const THREE = 51;
const FOUR = 52;
const FIVE = 53;
const SIX = 54;
const SEVEN = 55;
const EIGHT = 56;
const NINE = 57;
const RED = 403;
const GREEN = 404;
const YELLOW = 405;
const BLUE = 406;
const PLAY = 415;
const PAUSE = 19;
const PLAY_PAUSE = 10_252;
const STOP = 413;
const REWIND = 412;
const REWIND_LONG = 10_232;
const FAST_FORWARD = 417;
const FAST_FORWARD_LONG = 10_233;
const BACK = 461;
const DONE = 65_376;
const CANCEL = 65_385;

export default {
  back: BACK,
  navigation: {
    left: LEFT,
    up: UP,
    right: RIGHT,
    down: DOWN,
    enter: ENTER,
  },
  mediaControl: {
    play: PLAY,
    pause: PAUSE,
    stop: STOP,
    playPause: PLAY_PAUSE,
    fastForward: FAST_FORWARD,
    fastForwardLong: FAST_FORWARD_LONG,
    rewind: REWIND,
    rewindLong: REWIND_LONG,
  },
  channel: {
    up: CHANNEL_UP,
    down: CHANNEL_DOWN,
  },
  color: {
    red: RED,
    green: GREEN,
    yellow: YELLOW,
    blue: BLUE,
  },
  numbers: [
    ZERO,
    ONE,
    TWO,
    THREE,
    FOUR,
    FIVE,
    SIX,
    SEVEN,
    EIGHT,
    NINE,
  ],
  virtualKeyboard: {
    done: DONE,
    cancel: CANCEL,
  },
};
